import React from 'react';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { IInvoiceFullObject } from '../../Interfaces/IInvoice';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { InvoiceRow } from './InvoiceRow';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { ILegalRole } from '../../Interfaces/ILegalRole';
import { ILegalTransactionType } from '../../Interfaces/ILegalTransactionType';
import { useGetInvoicesStates } from '../../hooks/reactQuerys/InvoiceQueries';
import { ILegalTransactionRecordNumber } from '../../Interfaces/ILegalTransactionRecordNumber';

interface IProps {
  idLegalTransaction: number;
  downloadedArray?: IDocumentDownloaded[];
  invoiceObjectArray: IInvoiceFullObject[];
  setInvoiceObjectArray: Function;
  //
  assignedLegalClients: ILegalClient[];
  setLegalClients: Function;
  legalRoles: ILegalRole[];
  legalTransactionTypes: ILegalTransactionType[];

  recordNumberArray: ILegalTransactionRecordNumber[];
}

export const InvoiceTable: React.FC<IProps> = ({
  idLegalTransaction,
  downloadedArray,
  invoiceObjectArray,
  setInvoiceObjectArray,
  assignedLegalClients,
  setLegalClients,
  legalRoles,
  legalTransactionTypes,
  recordNumberArray,
}) => {
  const { invoiceStates, isLoadinginvoiceStates, refetchinvoiceStates } =
    useGetInvoicesStates();

  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table sx={{ minWidth: 760 }}>
        <TableHead>
          <TableRow>
            <TableCell width={'5%'}>Nr.</TableCell>
            {downloadedArray && <TableCell width={'5%'}>Runter.</TableCell>}
            <TableCell width={'20%'}>
              Art /<br /> Urkundennummer
            </TableCell>
            <TableCell width={120}>Status</TableCell>
            <TableCell width={'20%'}>
              Zahlungsschuldner /<br />
              Rechnungssumme
            </TableCell>
            <TableCell>Dateiname</TableCell>
            <TableCell width={100}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceObjectArray.map(invoice => (
            <InvoiceRow
              key={`invoice-${invoice.idInvoice}`}
              invoiceObject={invoice}
              invoiceObjectArray={invoiceObjectArray}
              setInvoiceObjectArray={setInvoiceObjectArray}
              downloadedArray={downloadedArray}
              assignedLegalClients={assignedLegalClients}
              legalRoles={legalRoles}
              setLegalClients={setLegalClients}
              legalTransactionTypes={legalTransactionTypes}
              invoiceStates={invoiceStates}
              isLoadinginvoiceStates={isLoadinginvoiceStates}
              recordNumberArray={recordNumberArray}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
